import { render } from "./link-company-invenias.vue?vue&type=template&id=038e7598"
import script from "./link-company-invenias.vue?vue&type=script&lang=js"
export * from "./link-company-invenias.vue?vue&type=script&lang=js"

import "./link-company-invenias.vue?vue&type=style&index=0&id=038e7598&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__